document.addEventListener('DOMContentLoaded', function() {
    let endImpression = 0;

    function impression(index, element, product, items, page) {
        ga('ec:addImpression', {
            'id': element.dataset.id,
            'name': element.dataset.name,
            'category': element.dataset.category,
            'brand': element.dataset.make,
            'variant': element.dataset.colour,
            'list': element.dataset.list,
            'position': index + 1 + endImpression,
        });

        if (index + 1 == items.length) {
            if (page == 1) {
                const productPageTop = document.getElementById('product-page-top');
                if (productPageTop && productPageTop.parentElement && productPageTop.parentElement.dataset.analyticsUrl) {
                    ga('send', 'pageview', productPageTop.parentElement.dataset.analyticsUrl);
                } else {
                    ga('send', 'pageview');
                }
            } else {
                ga('send', 'event', 'Tariff Tables', 'Load More Deals');
            }

            endImpression = items.length * page;
        }
    }

    function processImpressions(page) {
        const dealButtons = document.querySelectorAll('[data-listing-tile] [data-listing-tile-variation].active .view-deals-button');
        const dealButtonsArray = Array.from(dealButtons).slice(endImpression);
        dealButtonsArray.forEach(function(button, index) {
            impression(index, button, false, dealButtonsArray, page);
        });

        const listingButtons = document.querySelectorAll('.deal-box .buy-button, [data-listing-tile]:not([data-category-tile]) a[data-listing-tile-button]');
        const listingButtonsArray = Array.from(listingButtons).slice(endImpression);
        listingButtonsArray.forEach(function(button, index) {
            impression(index, button, true, listingButtonsArray, page);
        });
    }

    processImpressions(1);
    analyticsTiming();

    // Custom event listener for deals-displayed
    document.addEventListener('cdt.deals-displayed', function(event) {
        processImpressions(event.detail.page || 1);
    });
});

document.addEventListener('click', function(event) {
    const viewDealsButton = event.target.closest('.view-deals-button');
    if (viewDealsButton) {
        event.preventDefault();
        try {
            ga('ec:addProduct', {
                'id': viewDealsButton.dataset.id,
                'name': viewDealsButton.dataset.name,
                'category': viewDealsButton.dataset.category,
                'brand': viewDealsButton.dataset.brand,
                'variant': viewDealsButton.dataset.variant,
                'position': viewDealsButton.dataset.position
            });
            ga('ec:setAction', 'click', {
                list: viewDealsButton.dataset.list
            });

            // Send click with an event, then send user to product page.
            ga('send', 'event', 'UX', 'click', 'Results');
        } finally {
            document.location = viewDealsButton.getAttribute('href');
        }
    }
});

document.addEventListener('click', function(event) {
    const buyButton = event.target.closest('.buy-button');
    if (buyButton) {
        event.preventDefault();
        try {
            ga('ec:addProduct', {
                'id': buyButton.dataset.id,
                'name': buyButton.dataset.name,
                'category': buyButton.dataset.category,
                'brand': buyButton.dataset.brand,
                'variant': buyButton.dataset.colour,
                'price': buyButton.dataset.price,
                'quantity': buyButton.dataset.quantity,
                'list': '/product/' + buyButton.dataset.slug.toLowerCase()
            });
            ga('ec:setAction', 'add');
            ga('send', 'event', 'UX', 'click', 'Buy Now');
        } finally {
            if (buyButton.getAttribute('data-coverage-checker')) {
                setUpCoverageCheckerModal(event);
            } else {
                document.location = buyButton.getAttribute('href');
            }
        }
    }
});

function analyticsTiming() {
    if (window.performance) {
        let timeSincePageLoad = Math.round(performance.now());

        ga('send', 'timing', 'JS Dependencies', 'load', timeSincePageLoad);
    }
}

function setUpCoverageCheckerModal(event) {
    const buyButton = event.currentTarget.closest('.buy-button');
    const modalSelector = buyButton.getAttribute('data-coverage-checker');
    const modal = document.querySelector(modalSelector);

    if (modal) {
        const continueButton = modal.querySelector('[data-continue-to-basket]');
        if (continueButton) {
            continueButton.setAttribute('href', buyButton.getAttribute('href'));
        }

        // Bootstrap modal still requires jQuery
        if (typeof $ !== 'undefined') {
            $(modal).modal();
        }
    }
}
